import { motion, useAnimationControls } from "framer-motion"
import React, { useEffect } from "react"
import styled from "styled-components/macro"

interface Props {
  selectedIndex: number
  demos: { title: string; url: string; image1: string; image2: string }[]
  className?: string
}

export const PhonesDemo = (props: Props): JSX.Element => {
  const [hover, setHover] = React.useState(false)

  const controls = useAnimationControls()

  useEffect(() => {
    props.demos.forEach(demo => {
      const img1 = new Image()
      img1.src = demo.image1
      const img2 = new Image()
      img2.src = demo.image2
    })
  }, [])

  useEffect(() => {
    if (hover) {
      controls.start({ scale: 1.05 })
    } else {
      controls.start({ scale: 1 })
    }
  }, [hover])

  useEffect(() => {
    controls.start({ scale: [1, 1.05, 1], transition: { duration: 0.4 } })
  }, [props.selectedIndex])

  return (
    <S_PhonesDemo className={props.className}>
      <S_Phones animate={controls}>
        <S_PhoneA />
        <S_PhoneB />

        <S_Screens>
          <S_ScreenA $img={props.demos[props.selectedIndex].image1} />
          <S_ScreenB $img={props.demos[props.selectedIndex].image2} />
        </S_Screens>

        <S_Link
          target="_blank"
          href={props.demos[props.selectedIndex].url}
          onMouseOver={() => {
            console.log("Hover")
            setHover(true)
          }}
          onMouseLeave={() => {
            setHover(false)
          }}
        />
      </S_Phones>
    </S_PhonesDemo>
  )
}

const S_PhonesDemo = styled(motion.div)`
  width: calc(301px * 1.1);
  height: calc(353px * 1.1);
  @media only screen and (min-width: 1260px) {
    width: calc(301px * 1.9);
    height: calc(353px * 1.9);
  }
`

const S_Phones = styled(motion.div)`
  position: relative;
  width: 100%;
  height: 100%;
`

const S_Link = styled.a`
  position: absolute;
  width: calc(301px * 1.1);
  height: calc(353px * 1.1);
  top: 0;
  left: 0;
  z-index: 100;
  font-size: 15px;
  @media only screen and (min-width: 1260px) {
    width: 470px;
    left: 35px;
    top: 40px;
    height: 543px;
  }
`

const S_Phone = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-size: contain;
  background-repeat: no-repeat;
  width: calc(301px * 1.1);
  height: calc(353px * 1.1);
  @media only screen and (min-width: 1260px) {
    width: calc(301px * 1.9);
    height: calc(353px * 1.9);
  }
`

const S_PhoneA = styled(S_Phone)`
  background-image: url("/phones0a.png");
  z-index: 10;
`

const S_PhoneB = styled(S_Phone)`
  background-image: url("/phones0b.png");
  z-index: 5;
`

const S_Screens = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
`

const S_ScreenA = styled(S_Phone)<{ $img: string }>`
  z-index: 11;
  background-image: url(${props => props.$img});
`

const S_ScreenB = styled(S_Phone)<{ $img: string }>`
  z-index: 6;
  background-image: url(${props => props.$img});
`
